module.exports = __webpack_public_path__ + "static/media/Google Pixel 4 Oh So Orange.6a5095ba.png";